import { observer } from "mobx-react-lite";
import { useContext, useEffect, useRef, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Button, Card, Col, Row } from "reactstrap";
import { StreamManager } from 'openvidu-browser';
import "../../assets/scss/broadcastController/broadcastController.scss";
import GenericModal from "../common/GenericModal";
import BroadcastSettings from "./BroadcastSettings";
import { BroadcastUserDataDto, UserTypes, broadcastBasePortatritsDimensions } from "../../app/models/broadcast";
import BroadcastUserChoiseFrom from "./BroadcastUserChoiseFrom";
import DynamicGridContainer from "../containers/DynamicGridContainer";
import GenericConfirmModal from "../common/GenericConfirmModal";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import GenericButton from "../common/GenericButton";
import BroadcastVideoPortrait from "./BroadcastVideoPortrait";


const BroadcastController = () => {
 const rootStore = useContext(RootStoreContext);
 const { theme } = rootStore.commonStore;
 const { 
  toggleIsBroadcastControllerOpen,
  launcherMode,
  leaveSession,
  closeSession,
  updateSetting,
  toggleAudio,
  toggleVideo,
  updateSession,
  toggleHandRaised,
  toggleAllGrabbers,
  toggleUserChoideModalOpen,
  checkPermissions,
  authorizedCamera,
  needWebcam,
  authorizedMicrophone,
  meetingTitle,
  session,
  publisher,
  subscribers,
  broadcastSettings,
  isMicrophoneActive,
  isCameraActive,
  isSpeaking,
  userType,
  absentUsersList,
  chairman,
  internalRaisedhands,
  externalRaisedhands,
  internalLoweredhands,
  externalLoweredhands,
  userChoiseModalOpen,
  canEditBroadcast,
  connecting,
  broadcastUser,
  grabbersList
 } = rootStore.broadcastStore;
 const [displayVideoPortraits, setDisplayVideoPortratis] = useState<boolean>(true)
 const [disableDashboardSwitch, setDisableDashboardSwitch] = useState<boolean>(false)
 const fullScreenRef = useRef<HTMLDivElement>(null);
 const [settingModalOpen, setSettingModalOpen] = useState(false);
 const [closeSessionModal, setCloseSessionModal] = useState(false);
 const [fullScreen, setFullScreen] = useState(false);
 const [isGrabbersDetailsOpen, setIsGrabbersDetailsOpen] = useState(false);
 const [singleFullScreen, setSingleFullScreen] = useState<string | undefined>(undefined);
 const [t] = useTranslation(["translation"], translationHookOptions);
 const [touchStartX, setTouchStartX] = useState<number | null>(null); // Stato per memorizzare la posizione X del tocco iniziale


//  const [dBLevel, setDBLevel] = useState<number | null>(null);

//   const handleDBLevelChange = (newDBLevel: number | null) => {
//     setDBLevel(newDBLevel);
//   };
useEffect(() => {
  if([...subscribers, publisher].length > 0 && (broadcastUser.broadcastUserTypeId !== UserTypes.external ? false : [...subscribers, publisher].filter(x => x !== undefined && JSON.parse(x!.stream.connection.data).userType !== UserTypes.grabber).length === 0)){
    setDisplayVideoPortratis(false)
    setDisableDashboardSwitch(true)
  } else {
    setDisableDashboardSwitch(false)
  }
}, [subscribers, publisher, broadcastUser.broadcastUserTypeId]);

const toggleAllFullScreen = async () => {
  if(fullScreen === false && singleFullScreen === undefined){
    setFullScreen(true);
  }else{
    setFullScreen(false);
  }

  if(singleFullScreen !== undefined){
    setSingleFullScreen(undefined);
  }
}

const toggleSingleFullScreen = async (id?: string) => {
  if(id && singleFullScreen === undefined){
    setSingleFullScreen(id);
  } else {
    setSingleFullScreen(undefined)
  }
};

// // Funzione per rimuovere un subscriber specifico
// const removeSubscriber = (subscriberToRemove : Subscriber) => {
//   if (session !== null) {
//     const updatedSubscribers = subscribers.filter(
//       (subscriber) => subscriber.stream.connection.connectionId !== subscriberToRemove.stream.connection.connectionId
//     );
//     setSubscribers(updatedSubscribers);
//   }
// };

const organizedPortaits = () => {
  
  let standardFullScreen = fullScreen && singleFullScreen === undefined;
  let portraits : JSX.Element[] = [];
  let videoClassName= standardFullScreen ?
    "subscriber-div subscriber stream-container " + (singleFullScreen !== undefined ? "subscriberSingleFullScreen singleFullScreenPortrait":"subscriber ")
    :
    "subscriber-div subscriber stream-container " + (singleFullScreen !== undefined ? "subscriberSingleFullScreen singleFullScreenPortrait":"subscriber col-md-6 col-xs-6")
  if(subscribers){
    subscribers.filter(x => JSON.parse(x.stream.connection.data).userType === UserTypes.grabber).map( subscriber => {
      console.log("trovato grabber", subscriber)
      portraits.push(<BroadcastVideoPortrait key={"videoPortratiUpperDiv" + subscriber.stream.connection.connectionId} subscriber={subscriber} userType={userType} singleFullScreen={singleFullScreen} fullScreen={fullScreen} toggleSingleFullScreen={toggleSingleFullScreen} videoClassName={videoClassName} />);
    })
  }
  if(publisher){
      portraits.push(<BroadcastVideoPortrait key={"videoPortratiUpperDiv" + publisher.stream.connection.connectionId} publisher={publisher} userType={userType} singleFullScreen={singleFullScreen} fullScreen={fullScreen} toggleSingleFullScreen={toggleSingleFullScreen} videoClassName={videoClassName} />);
      console.log("trovato publisher", publisher)
    }
  if(subscribers){
    subscribers.filter(x => JSON.parse(x.stream.connection.data).userType !== UserTypes.grabber).map( subscriber => {
      console.log("trovato utente", subscriber)
      portraits.push(<BroadcastVideoPortrait key={"videoPortratiUpperDiv" + subscriber.stream.connection.connectionId} subscriber={subscriber} userType={userType} singleFullScreen={singleFullScreen} fullScreen={fullScreen} toggleSingleFullScreen={toggleSingleFullScreen} videoClassName={videoClassName} />);
    })
  }

  let elementToReturn : JSX.Element;
  if(standardFullScreen){
    elementToReturn = (
      <DynamicGridContainer 
        elements= {[...portraits]}
        className="dynamicGridContainer"
      />
    )
  } else {
    elementToReturn = (
      <Row className="videoPortraitsContainer">
        {portraits.length > 0 && portraits.map( portrait => 
          portrait
          )}
      </Row>
    )
  }
  return (elementToReturn);
}
const PortraitsOrPartecipants = () =>{
  return(
    <>
   {(fullScreen || singleFullScreen || displayVideoPortraits) &&
    (
      <div className={(fullScreen || singleFullScreen) ? (singleFullScreen !== undefined ? "lateralPortraitsPanelSingleFS" : displayVideoPortraits ? "lateralPortraits100PanelFS" : "lateralPortraitsPanelFS") : "lateralPortraitsPanel"}
      style={{ overflowY: 'auto', overflowX: 'hidden',scrollbarWidth: 'none'}}
      >
        {organizedPortaits()}
      </div>
    )}  
    {!displayVideoPortraits && (
      <div className={ (fullScreen || singleFullScreen) ? "lateralPartecipantPannelFS" : "lateralPartecipantPannel"} style={{ overflowY: 'auto', overflowX: 'hidden'}}>
        {chairman !== undefined && [chairman].map(() => {
        let userStream : StreamManager | undefined = subscribers.find(x => JSON.parse(x.stream.connection.data).userId === chairman.userId && JSON.parse(x.stream.connection.data).userType === chairman.broadcastUserTypeId)
        if(!userStream && publisher)
          userStream = JSON.parse(publisher.stream.connection.data).userId === chairman.userId ? publisher : undefined

        let userData : any = undefined;
        if(userStream)
            userData = JSON.parse(userStream.stream.connection.data);
          return(
          <Card key={chairman.userId} className={"partecipantsRow internalUser chairman"}>
            <Row className="noMargin">
              <Col className={"partecipantsCol"}><p className={"partecipantText"}>{chairman.username}</p></Col>
              <Col className="partecipantsCol partecipantsColButtonspartecipantsColNoMaxWidth">
                {chairman.isSpeaking && (
                  <div className="speakingIconContainer">
                    <i className ="fas fa-volume" style={{color: "#d10000"}}></i>
                  </div>
                )}
                {userData && userStream &&(
                  <>
                    {microphoneButton(0,"","partecipantsButtons",false,userStream.stream.audioActive,userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                    {cameraButton(0,"","partecipantsButtons",userStream.stream.videoActive,userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                  </>
                )}
              </Col>
            </Row>
          </Card>
        )})}
        {subscribers && [...externalLoweredhands,...internalLoweredhands].filter(x => x.isSpeaking === true).map((user) => {
          let userStream : StreamManager | undefined = subscribers.find(x => JSON.parse(x.stream.connection.data).userId === user.userId && JSON.parse(x.stream.connection.data).userType === user.broadcastUserTypeId)
                if(!userStream && publisher)
                  userStream = JSON.parse(publisher.stream.connection.data).userId === user.userId ? publisher : undefined
                let userData : any = undefined;
                if(userStream)
                    userData = JSON.parse(userStream.stream.connection.data);
                return(
                  <Card key={user.userId} className={"partecipantsRow " + (user.broadcastUserTypeId === UserTypes.internal ? "internalUser" : "externalUser")}>
                    <Row className="noMargin">
                      <Col className={"partecipantsCol" }><p className={"partecipantText"}>{user.username}</p></Col>
                          <Col className="partecipantsCol partecipantsColButtons partecipantsColNoMaxWidth">
                          <div className="speakingIconContainer">
                            <i className ="fas fa-volume" style={{color: "#d10000"}}></i>
                          </div>
                          {toggleHandButton(0,"","partecipantsButtons",user.handRaisedPriority,"partecipantsIcon",user.handRaisedPriority !== 0, userData ? userData.userId === broadcastUser.userId : true, false)}
                          {userStream && userData && (
                            <>
                              {microphoneButton(0,"","partecipantsButtons",false,userStream.stream.audioActive, userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                              {cameraButton(0,"","partecipantsButtons",userStream.stream.videoActive, userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                            </>
                          )}
                          </Col>
                    </Row>
                  </Card>
                )}
        )}
        {subscribers && internalRaisedhands.map((internalUser) => {
          let userStream : StreamManager | undefined = subscribers.find(x => JSON.parse(x.stream.connection.data).userId === internalUser.userId && JSON.parse(x.stream.connection.data).userType === internalUser.broadcastUserTypeId)
                if(!userStream && publisher)
                  userStream = JSON.parse(publisher.stream.connection.data).userId === internalUser.userId ? publisher : undefined
                let userData : any = undefined;
                if(userStream)
                    userData = JSON.parse(userStream.stream.connection.data);
                return (
                  <Card key={internalUser.userId} className={"partecipantsRow internalUser"} >
                    <Row className="noMargin">
                      <Col className={"partecipantsCol"}><p className={"partecipantText"}>{internalUser.username}</p></Col>
                          <Col className="partecipantsCol partecipantsColButtons partecipantsColNoMaxWidth">
                            {toggleHandButton(0,"","partecipantsButtons",internalUser.handRaisedPriority,"partecipantsIcon",internalUser.handRaisedPriority !== 0, userData ? userData.userId === broadcastUser.userId : true, false)}
                            {userStream && userData && (
                              <>
                                {microphoneButton(0,"","partecipantsButtons",false,userStream.stream.audioActive ,userData.userType,"partecipantsIcon", userData.userId === broadcastUser.userId, false)}
                                {cameraButton(0,"","partecipantsButtons",userStream.stream.videoActive,userData.userType,"partecipantsIcon", userData.userId === broadcastUser.userId, false)}
                              </>
                            )}
                          </Col>
                    </Row>
                  </Card>
                )}
        )}
        {subscribers && externalRaisedhands.map((externalUser) => {
                let userStream : StreamManager | undefined = subscribers.find(x => JSON.parse(x.stream.connection.data).userId === externalUser.userId && JSON.parse(x.stream.connection.data).userType === externalUser.broadcastUserTypeId)
                if(!userStream && publisher)
                  userStream = JSON.parse(publisher.stream.connection.data).userId === externalUser.userId ? publisher : undefined
                let userData : any = undefined;
                if(userStream)
                    userData = JSON.parse(userStream.stream.connection.data);
                return (
                  <Card key={externalUser.userId} className={"partecipantsRow externalUser"} >
                    <Row className="noMargin">
                        <Col className={"partecipantsCol"}><p className={"partecipantText"}>{externalUser.username}</p></Col>
                            <Col className="partecipantsCol partecipantsColButtons partecipantsColNoMaxWidth">
                                {toggleHandButton(0,"","partecipantsButtons",externalUser.handRaisedPriority,"partecipantsIcon", externalUser.handRaisedPriority !== 0, userData ? userData.userId === broadcastUser.userId : true, false)}
                                {userStream && userData && (
                                  <>
                                    {microphoneButton(0,"","partecipantsButtons",false,userStream.stream.audioActive,userData.userType,"partecipantsIcon", userData.userId === broadcastUser.userId, false)}
                                    {cameraButton(0,"","partecipantsButtons",userStream.stream.videoActive,userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                                  </>
                                )}
                            </Col>
                    </Row>
                  </Card>
                )}
        )}
        {subscribers && internalLoweredhands.filter(x => x.isSpeaking === false || x.isSpeaking === undefined).map((internalUser) => {
                let userStream : StreamManager | undefined = subscribers.find(x => JSON.parse(x.stream.connection.data).userId === internalUser.userId && JSON.parse(x.stream.connection.data).userType === internalUser.broadcastUserTypeId)
                if(!userStream && publisher)
                  userStream = JSON.parse(publisher.stream.connection.data).userId === internalUser.userId ? publisher : undefined
                let userData : any = undefined;
                if(userStream)
                    userData = JSON.parse(userStream.stream.connection.data);
                return(
                <Card key={internalUser.userId} className={"partecipantsRow internalUser"}>
                  <Row className="noMargin">
                    <Col className={"partecipantsCol" }><p className={"partecipantText"}>{internalUser.username}</p></Col>
                        <Col className="partecipantsCol partecipantsColButtons partecipantsColNoMaxWidth">
                          {toggleHandButton(0,"","partecipantsButtons",internalUser.handRaisedPriority,"partecipantsIcon",internalUser.handRaisedPriority !== 0, userData ? userData.userId === broadcastUser.userId : true, false)}
                          {userStream && userData && (
                            <>
                              {microphoneButton(0,"","partecipantsButtons",false,userStream.stream.audioActive,userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                              {cameraButton(0,"","partecipantsButtons",userStream.stream.videoActive,userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                            </>
                          )}
                        </Col>
                  </Row>
                </Card>
                )}
        )}
        {subscribers && externalLoweredhands.filter(x => x.isSpeaking === false || x.isSpeaking === undefined).map((externalUser) => {
               let userStream : StreamManager | undefined = subscribers.find(x => JSON.parse(x.stream.connection.data).userId === externalUser.userId && JSON.parse(x.stream.connection.data).userType === externalUser.broadcastUserTypeId)
                if(!userStream && publisher)
                  userStream = JSON.parse(publisher.stream.connection.data).userId === externalUser.userId ? publisher : undefined
                let userData : any = undefined;
                if(userStream)
                    userData = JSON.parse(userStream.stream.connection.data);
                return(
                  
                  <Card key={externalUser.userId} className={"partecipantsRow externalUser"}>
                    <Row className="noMargin">
                      <Col className={"partecipantsCol" }><p className={"partecipantText"}>{externalUser.username}</p></Col>
                          <Col className="partecipantsCol partecipantsColButtons partecipantsColNoMaxWidth">
                          {toggleHandButton(0,"","partecipantsButtons",externalUser.handRaisedPriority,"partecipantsIcon",externalUser.handRaisedPriority !== 0, userData ? userData.userId === broadcastUser.userId : true, false)}
                          {userStream && userData &&(
                            <>
                              {microphoneButton(0,"","partecipantsButtons",false,userStream.stream.audioActive, userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                              {cameraButton(0,"","partecipantsButtons",userStream.stream.videoActive, userData.userType,"partecipantsIcon",userData.userId === broadcastUser.userId, false)}
                            </>
                          )}
                          </Col>
                    </Row>
                  </Card>
                )}
        )}
        {absentUsersList && absentUsersList.map((user) => (
        <Card className={"partecipantsRow absentUser"} key={user.userId + "absentlist"}>
          <Row className="noMargin">
            <Col className={"partecipantsCol absentCol"}><p className={"partecipantText"}>{user.username}</p></Col>
            <Col className="partecipantsCol partecipantsColButtons absentCol partecipantsColNoMaxWidth">
              {t("absent")}
            </Col>
          </Row>
        </Card>
        ))}
      </div>
    )}
    </>
  )
}

const grabberDetailCard = (grabber : BroadcastUserDataDto) => {
return(
    <div className="grabberDetailsBody">
      <div className="truncate">{grabber.username}</div>
      <Button 
          key={"grabberActivation" + grabber.grabberId}
          className={`clickEffect btnDimension`}
          style={{backgroundColor: "rgb(189, 187, 187)",color: grabber.broadcastUserTypeId !== UserTypes.grabber ? "green" : "red"}}
          onClick={() => updateSession({...grabber, broadcastUserTypeId : (grabber.broadcastUserTypeId === UserTypes.grabber ? UserTypes.undefined : UserTypes.grabber)})}
          >
            {grabber.broadcastUserTypeId !== UserTypes.grabber ? (
              <i className="fas fa-play"></i>
            ) : (
              <i className="fas fa-stop"></i>
            )}
      </Button>
      <Button 
          key={"grabberRefresh" + grabber.grabberId}
          className={`clickEffect btnDimension`}
          style={{backgroundColor:"rgb(189, 187, 187)"}}
          onClick={() => {toggleHandRaised(grabber)}}
          >
            <i className="fas fa-sync-alt"></i>
      </Button>
    {grabber.error !== undefined && (
      <div style={{marginBottom: "2vh"}}>
        <p style={{color: "red"}}>{grabber.error}</p>
      </div>
    )}
    </div>
  )
}

const cameraButton = (colNumber : number = 0, addClassName : string = "", id : string ="", switchCondition : boolean = isCameraActive, userTypology : number = userType, addIconClassname : string = "", clickable : boolean = true, isControllerButton : boolean = true) => {
  if(userTypology !== UserTypes.internal && userTypology !== UserTypes.external)
    return(
    <GenericButton
      id={id}
      colNumber={colNumber}
      switchCondition={switchCondition}
      onClick={clickable ? toggleVideo : ()=>null}
      iconClassName={`fas fa-video-slash optionButtonText ${addIconClassname}`}
      buttonText = ""
      clickable = {clickable}
      buttonClassName = {`broadcastBTN optionCameraButton ${theme?.buttonTextColor} ${theme?.buttonColor} ${addClassName} ${clickable ? "clickEffect" : "notClickable"}`}
      switchedIconClassName = {`fas fa-video optionButtonText ${addIconClassname}`}
      buttonTextClassName = ""
      colClassName= "broadcastButtonsCol"
      tooltipText={clickable ? !switchCondition ? t("camera_buttonText_on") : t("camera_buttonText_off") : ""}
      tooltipClassName = {isControllerButton ?  (fullScreen === true || singleFullScreen !== undefined) ? " tooltipControllerButtonFS" : "tooltipControllerButton" : ""}
    />)
}
const microphoneButton = (colNumber : number = 0, addClassName : string = "", id : string ="", toggleActive : boolean = false, switchCondition : boolean = isMicrophoneActive, userTypology : number = userType, addIconClassname : string = "", clickable : boolean = true, isControllerButton : boolean = true) => {
  if(userTypology !== UserTypes.internal && userTypology !== UserTypes.external){
    return(
    <GenericButton
      id={id}
      colNumber={colNumber}
      switchCondition={switchCondition}
      onClick={clickable ? toggleAudio : ()=>null}
      iconClassName={`fas fa-microphone-slash optionButtonText ${addIconClassname}`}
      buttonText = ""
      clickable = {clickable}
      buttonClassName = {`broadcastBTN optionMicrophoneButton ${theme?.buttonTextColor} ${theme?.buttonColor} ${addClassName} ${clickable ? "clickEffect" : "notClickable"}`}
      switchedIconClassName = {`fas fa-microphone optionButtonText ${addIconClassname} ${toggleActive ? (isSpeaking ? 'active' : '') : ''}`}
      buttonTextClassName = ""
      colClassName= "broadcastButtonsCol"
      tooltipText={clickable ? !switchCondition ? t("microphone_buttonText_on") : t("microphone_buttonText_off") : ""}
      tooltipClassName = {isControllerButton ?  (fullScreen === true || singleFullScreen !== undefined) ? " tooltipControllerButtonFS" : "tooltipControllerButton" : ""}
    />)
  }
}
const toggleHandButton = (colNumber : number = 0, addClassName : string = "", id : string ="", handRaisedPriority : number = 0, addIconClassname : string = "", showButton: boolean = true, clickable : boolean = true, isControllerButton : boolean = true) => {
  if(showButton){
    return(
      <GenericButton
        id={id}
        colNumber={colNumber}
        switchCondition={handRaisedPriority > 0}
        onClick={clickable ? () => toggleHandRaised() : ()=>null}
        buttonText = ""
        clickable = {clickable}
        buttonClassName = {`broadcastBTN optionToggleHandButton ${theme?.buttonTextColor} ${theme?.buttonColor} ${addClassName} ${clickable ? "clickEffect" : "notClickable"}`}
        iconClassName={`fas fa-hand-paper optionButtonText ${addIconClassname}`}
        switchedIconClassName = {`fas fa-hand-paper optionButtonText greenColor ${addIconClassname}`}
        buttonTextClassName = ""
        colClassName= "broadcastButtonsCol"
        tooltipText={ clickable ? handRaisedPriority > 0 ? t("raise_hand_buttonText_off") : t("raise_hand_buttonText_on"): ""}
        tooltipClassName = {isControllerButton ?  (fullScreen === true || singleFullScreen !== undefined) ? " tooltipControllerButtonFS" : "tooltipControllerButton" : ""}
      />)
  }
}

 const handleClose = () => {
  // leaveSession();
  toggleIsBroadcastControllerOpen();
 }

 const handleChangeDashboard = (event : React.MouseEvent<HTMLButtonElement>) => {
    // const buttonElement = event.currentTarget as HTMLButtonElement;
      setDisplayVideoPortratis(!displayVideoPortraits)
 }

 const handleJoinOrLeave = async () => {
  if (!session && broadcastUser.broadcastUserTypeId !== UserTypes.external) {
    launcherMode();
  } else {
    await leaveSession();
  }
};

const handleOpenSettings = () => {
  // if(videoRef.current)
  // console.log(videoRef.current.srcObject)
  setSettingModalOpen(!settingModalOpen)
}

    return(
      <div 
      ref={fullScreenRef} 
      className={"broadcastFullScreen" + ((fullScreen || singleFullScreen) ? " fullScreenMode" : "")}
      >
      {fullScreen || singleFullScreen ? (
      <>
          <div className="broadcastHeaderFS" >
            <Col xs={2} md={2} lg={2} xl={2} style={{color:"white",textAlign:"center",display: "flex",alignItems: "center",  whiteSpace: 'nowrap',
                      overflow: 'hidden',textOverflow: "ellipsis"}}>{meetingTitle}</Col>
            <Col xs={7.5} md={7.5} lg={7.5} xl={7.5} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
              <button 
                  style={{width: "100%"}}
                  className={`joinVideoconferenceButton broadcastBTN rounded-pill clickEffect highlight ${theme?.buttonBorderColor} ${theme?.buttonTextColor} ${theme?.buttonColor}`} 
                  onClick={((authorizedCamera && authorizedMicrophone) || !needWebcam) ? handleJoinOrLeave : checkPermissions}
              >
                {connecting ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                  </div>
                  ) : (
                  <p style={{whiteSpace: "nowrap"}} key={"joinVideoconferenceButtonText"} className="joinVideoconferenceButtonText">{(authorizedCamera || !needWebcam) ? ((authorizedMicrophone || !needWebcam) ? (session === undefined && broadcastUser.broadcastUserTypeId !== UserTypes.external ? t("join_videoconference"): t("leave_videoconference")) : t("mic_auth")) : t("webCam_auth")}</p>
                )}
              </button>
            </Col>
            <Col xs={0.5} md={0.5} lg={0.5} xl={0.5} style={{padding: "0px",display:"flex",alignItems: "center"}}>
                    <button 
                        onClick={handleChangeDashboard} 
                        className={"highlight DashboardChoiseButtonFS headerTextColor"}
                    >
                      {displayVideoPortraits ? 
                      <i className="fas fa-users"></i>
                      :
                      <i className="fas fa-users-slash"></i>
                      }
                    </button>
                </Col>
                    {toggleHandButton(0.5,"btnDimension",`${broadcastUser.userId}_FSHandButton`, broadcastUser.handRaisedPriority,"", broadcastUser.broadcastUserTypeId !== UserTypes.internal)}
                    {microphoneButton(0.5,"btnDimension")}
                    {cameraButton(0.5,"btnDimension")}
                <Col xs={0.5} md={0.5} lg={0.5} xl={0.5} className={"broadcastButtonsCol"}>
                <div className="tooltip-wrapper"> {/* Avvolgi il bottone in un div */}
                    <Button 
                        className={`broadcastBTN optionFullScreenButton clickEffect btnDimension ${theme?.buttonSecondaryColor} ${theme?.buttonSecondaryBorderColor}`}
                        onClick={toggleAllFullScreen}
                    >
                        <i className="far fa-expand-wide optionButtonText"></i>
                    </Button>
                    <span className="tooltip-text tooltipControllerButtonFS">{t("full_screen_buttonText")}</span> {/* Tooltip */}
                </div>
                </Col>
          </div>
          <div className="broadcastBodyFS">

          {PortraitsOrPartecipants()}
          </div>
      </> 
      ) : (
        <div className="broadcastControllerContainer">
          {/* <SoundLevelMonitor onDBLevelChange={handleDBLevelChange}></SoundLevelMonitor> */}
            <Card className="broadcastControllerCard">
            <Row style={{width: "100%"}}>
              {userType === UserTypes.internal ? (
                <div className={"cursor"} style={{width: "15%", textAlign:"initial"}} onClick={ toggleAllFullScreen}>
                  <i className="far fa-expand-wide fullScreenBtnInternalUsers clickEffect highlight broadcastButton" ></i>
                </div>
              ) : userType !== UserTypes.external ? (
                <div className={"cursor"} style={{width: "15%", textAlign:"initial"}} onClick={ handleOpenSettings}>
                  <i className="fas fa-cog clickEffect highlight broadcastButton settingIcon" ></i>
                </div>
              ) : (
                <div style={{width: "15%", textAlign:"initial"}}>
                </div>
              )}
              <div style={{width: "70%", textAlign:"center", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <button 
                      className={`joinVideoconferenceButton broadcastBTN rounded-pill clickEffect highlight ${theme?.buttonBorderColor} ${theme?.buttonTextColor} ${theme?.buttonColor}`} 
                      onClick={((authorizedCamera && authorizedMicrophone) || !needWebcam) ? handleJoinOrLeave : checkPermissions}
                  >
                    {connecting ? (
                      <div className="loader-container">
                        <div className="loader"></div>
                      </div>
                      ) : (
                      <p key={"joinVideoconferenceButtonText"} className="joinVideoconferenceButtonText">
                        {(authorizedCamera || !needWebcam) ? ((authorizedMicrophone || !needWebcam) ? (session === undefined && broadcastUser.broadcastUserTypeId !== UserTypes.external ? t("join_videoconference"): t("leave_videoconference")) : t("mic_auth")) : t("webCam_auth")}
                      </p>
                    )}
                  </button>
              </div>
              <div className={"cursor"} style={{width: "15%", textAlign:"end"}}  onClick={handleClose}>
                  <i className="fas fa-times clickEffect highlight broadcastButton closeButtonIcon"></i>
              </div>
            </Row>
            {(broadcastUser.canHandleGrabbers || canEditBroadcast) && (
              <>
                <Row className={"GrabberPanelHeader"}>
                {grabbersList.length !== 0 && (
                     <Col xs={4} md={4} lg={4} xl={4} className="GrabberButtonsCol">
                     <Button 
                       outline style={{ boxShadow: 'none', display: (!broadcastUser.canHandleGrabbers || grabbersList.length === 0) ? "none" : "" }}
                       onClick={() => toggleAllGrabbers(true)} 
                       className={`clickEffect highlight ${theme?.buttonBorderColor} ${theme?.buttonTextColor} ${theme?.buttonColor} GrabberPanelButton GrabbersButton`} 
                       // disabled={grabbersList.length === 0}
                     >
                       <p className="GrabberButtonText">{t("play_all_grabbers")}</p>
                     </Button>
                   </Col>
                  )}
                 {grabbersList.length !== 0 && (
                  <Col xs={4} md={4} lg={4} xl={4} className="GrabberButtonsCol">
                    <Button 
                      outline style={{ boxShadow: 'none', display: (!broadcastUser.canHandleGrabbers || grabbersList.length === 0) ? "none" : ""}}
                      onClick={() => toggleAllGrabbers(false)} 
                      className={`clickEffect highlight ${theme?.buttonBorderColor} ${theme?.buttonTextColor} ${theme?.buttonColor} GrabberPanelButton GrabbersButton`} 
                      // disabled={grabbersList.length === 0}
                    >
                      <p className="GrabberButtonText">{t("stop_all_grabbers")}</p>
                    </Button>
                  </Col>
                 )}
                  {session !== undefined && (
                    <Col xs={4} md={4} lg={4} xl={4} className="GrabberButtonsCol">
                    <Button 
                      outline
                      onClick={() => setCloseSessionModal(true)} 
                      className={`clickEffect highlight GrabberPanelButton CloseSessionButton`}
                      style={{backgroundColor: "#C00000", boxShadow: 'none', color: 'white'}}
                    >
                      <p className="GrabberButtonText ">{t("stop_video_call")}</p>
                    </Button>
                  </Col>
                  )}
                </Row>
                <Row key={"grabberList_Row" +grabbersList.length} className="GrabberPanelBody" style={{display: (!broadcastUser.canHandleGrabbers || grabbersList.length === 0) ? "none" : ""}}>
                  <Col xs={1.5} md={1.5} lg={1.5} xl={1.5} className="GrabberPanelBodyCol">
                  <p style={{
                      display: "contents", 
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis', 
                      color : (grabbersList.filter(x => x.error !== undefined).length > 0 ? "red" : "#1E3050")
                    }}
                  >
                    {t("grabberList") + " (" + ((grabbersList.filter(x => x.error !== undefined).length > 0) ? grabbersList.filter(x => x.error !== undefined).length : grabbersList.length) + ")"}
                  </p>
                  <i 
                    onClick={() => setIsGrabbersDetailsOpen(!isGrabbersDetailsOpen)}
                    className={(isGrabbersDetailsOpen ? "fas fa-chevron-up" : "fas fa-chevron-down") + " GrabberOpenDetailsButtonIcon"}
                    style={{color : (grabbersList.filter(x => x.error !== undefined).length > 0 ? "red" : "#1E3050")}}
                  >
                  </i>
                  </Col>
              </Row>
              {isGrabbersDetailsOpen && (
                <>
                  {grabbersList.map((grabber, index) => 
                    <div key={"GrabberDetails_" + grabber.grabberId} className="GrabberPanelFooter" style={{width:"100%", backgroundColor: (index % 2 === 0) ? "lightgrey" : "#adadad"}}>
                        {grabberDetailCard(grabber)}
                    </div>
                  )}
                </>
              )}
              </>
            )}
            <Row style={{borderBottom: "2px solid #00000075", width: "95%",justifyContent: "center"}}>
              {[...subscribers, publisher].length > 0 && (broadcastUser.broadcastUserTypeId !== UserTypes.external ? true : [...subscribers, publisher].filter(x => x !== undefined && JSON.parse(x!.stream.connection.data).userType !== UserTypes.grabber).length > 0) && (
                <Col xs={4} md={4} lg={4} xl={4} style={{padding: "0px"}}>
                    <button 
                        onClick={handleChangeDashboard} 
                        className={"highlight DashboardChoiseButton " + (displayVideoPortraits === true ? `${theme?.headerColor} ${theme?.headerTextColor}` : "")} 
                    >
                        <p className="dashboardButtonText">VIDEO</p>
                    </button>
                </Col>
              )}
                
                <Col xs={8} md={8} lg={8} xl={8} style={{padding: "0px"}}>
                    <button 
                        onClick={handleChangeDashboard} 
                        className={"highlight DashboardChoiseButton " + (displayVideoPortraits === false ? `${theme?.headerColor} ${theme?.headerTextColor}` : "")}
                        disabled={disableDashboardSwitch}
                    >
                        <p className="dashboardButtonText">{t("partecipants")}</p>
                    </button>
                  </Col>
            </Row>
            {userType !== UserTypes.internal && (
            <Row className="panelButtonsRow">
                {microphoneButton(3,"btnDimension")}
                {cameraButton(3,"btnDimension")}
                {toggleHandButton(3,"btnDimension",`${broadcastUser.userId}_handButton`, broadcastUser.handRaisedPriority )}
                {!disableDashboardSwitch && (
                  <Col xs={3} md={3} lg={3} xl={3} className={"broadcastButtonsCol"}>
                    <div className="tooltip-wrapper">
                    <Button 
                        className={`broadcastBTN optionFullScreenButton clickEffect btnDimension ${theme?.buttonSecondaryColor} ${theme?.buttonSecondaryBorderColor}`}
                        onClick={toggleAllFullScreen}
                    >
                        <i className="far fa-expand-wide optionButtonText"></i>
                    </Button>
                    <span className="tooltip-text tooltipControllerButton">{t("full_screen_buttonText")}</span> {/* Tooltip */}
                    </div>
                </Col>
                )}
            </Row>
            )}
            {PortraitsOrPartecipants()}
          </Card>
          <GenericModal
            content={
              <BroadcastSettings 
              toggle={() => setSettingModalOpen(!settingModalOpen)}
              broadcastSettings={broadcastSettings}
              onSettingsChange={updateSetting}
              />}
            isOpen={settingModalOpen}
            toggle={() => setSettingModalOpen(!settingModalOpen)}
            title={t("settings")}
            />
          <GenericModal
          modalClassname= "broadcastUserChoiseModal"
            content={
              <BroadcastUserChoiseFrom
              toggle={() => toggleUserChoideModalOpen(!userChoiseModalOpen)}
              />}
            isOpen={userChoiseModalOpen}
            toggle={() => toggleUserChoideModalOpen(!userChoiseModalOpen)}
            title={t("connect_to_video_call_using")}
            />
          <GenericConfirmModal
              title={t("stop_video_call")} 
              isOpen={closeSessionModal} 
              toggle={() => setCloseSessionModal(!closeSessionModal)}
              action={closeSession} 
              messages={[t("confirm_close_session_mex_1"), t("confirm_close_session_mex_2")]}
              classNamesObj={{footerClassname: "closeSessionModalFooter"}}
              />
        </div>
        )}
      </div>
    )
}


export default observer(BroadcastController);